import React from "react";
import Footer from "../Fotter";

function UseIt() {
  return (
    <div>
      <div className=" mx-auto px-4 py-6">
        <h1 className="text-3xl font-bold mb-6">Order Details and More</h1>

        {/* How to Order Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">How to Order?</h2>
          <ol className="list-decimal pl-6 text-gray-700 space-y-2">
            <li>
              Open{" "}
              <a
                href="https://www.bharatCod.com/"
                className="text-blue-500 underline"
              >
                https://www.bharatCod.com/
              </a>
            </li>
            <li>Choose your product</li>
            <li>Click on the “Add to Cart” button</li>
            <li>Click on the “Proceed to Checkout” button</li>
            <li>Fill in all your billing details on the checkout page</li>
            <li>
              Check your order details and click on the “Place Order” button
            </li>
          </ol>
          <p className="mt-4 text-gray-600">
            After successful payment, you’ll receive an order confirmation via
            email, SMS, or WhatsApp. You’ll receive your ordered product within
            7-8 working days from the order date.
          </p>
        </div>

        {/* How to Return or Refund Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            How to Return or Refund My Order?
          </h2>
          <p className="text-gray-700 mb-2">
            bharatCod refund & return policies are well mentioned on our
            website.
          </p>
          <p className="text-gray-700">
            Also, contact bharatCod Customer Care for return & refund orders.
          </p>
        </div>

        {/* How to Change Address or Contact Number Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            How to Change My Address or Contact Number?
          </h2>
          <p className="text-gray-700">
            To change any details of your order, contact bharatCod Customer
            Care.
          </p>
        </div>

        {/* How to Cancel My Order Section */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">
            How to Cancel My Order?
          </h2>
          <p className="text-gray-700">
            In the "My Account" section, go to “Orders” and click on the cancel
            button in the actions column.
          </p>
        </div>
        <section className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Customer Support</h2>
          <p>
            <strong>Address:</strong> 403, Shagun Tower, Above Apna Sweets,
            Scheme Number 54,P.u.4,AB Rd,vijay Nagar,Indore,Madhy Pradesh 452010
            Pradesh
          </p>
          <p>
            <strong>Phone:</strong> (+91) 9399456176
          </p>
          <p>
            <strong>E-mail:</strong> info@bharatCod.com
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a
              href="http://www.bharatCod.com"
              className="text-blue-500 underline"
            >
              www.bharatCod.com
            </a>
          </p>
          <div className="mb-10 flex  space-x-6">
            <a
              href="https://www.facebook.com/thebharatcod"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook fa-2x text-blue-600 hover:text-blue-800"></i>
            </a>
            <a
              href="https://www.instagram.com/bharatcod/#"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram fa-2x text-pink-500 hover:text-pink-700"></i>
            </a>
            <a
              href="https://in.pinterest.com/thebharatcod/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-pinterest fa-2x text-blue-700 hover:text-blue-900"></i>
            </a>
            <a
              href="https://www.youtube.com/channel/UC5TRs6-BjCd9QgDbP8YKvEQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube fa-2x text-red-700 hover:text-red-700"></i>
            </a>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default UseIt;
